import { gql } from '@apollo/client';

export const GET_VEHICLES = gql(/* GraphQL */ `
query GetEquipmentVehicles(
  $limit: Int = 25,
  $offset: Int = 0,
  $filter: EquipmentVehicleFilterInput,
  $orderBy: EquipmentVehicleOrderByInput,
  $customsTerritories: [String!]!,
) {
  equipmentVehicle {
    list(
      limit: $limit,
      offset: $offset,
      filter: $filter,
      orderBy: $orderBy,
      customsTerritories: $customsTerritories
    ) {
      items {
        id
        health {
          health
        }
        voyageNumber
        plannedDischargeDate
        modeOfTransport
        carrier
        originCountry
        dischargeCountry
        openExceptionCount
        consignmentCount
        expectedShipmentCount
        actualShipmentCount
      }
      pageInfo {
        totalCount
        status
        message
      }
    }
  }
  
}`);

export const LIST_VEHICLE_COUNTRIES = gql`
  query ListVehicleCountries($fieldType: String!, $customsTerritories: [String!]!) {
    equipmentVehicle {
      listCountries(fieldType: $fieldType, customsTerritories: $customsTerritories)
    }
  }
`;

export const GET_VEHICLE = gql`
  query GetEquipmentVehicle($id: ID!) {
    equipmentVehicle {
      get(id: $id) {
        id
        health {
          health
          description
        }
        voyageNumber
        plannedDischargeDate
        modeOfTransport
        carrier
        originCountry
        dischargeCountry
        openExceptionCount
        consignmentCount
        expectedShipmentCount
        actualShipmentCount
      }
    }
  }
`;

export const GET_VEHICLE_CONSIGNMENTS = gql`
  query GetVehicleConsignments(
    $vehicleId: ID!,
    $limit: Int = 25,
    $offset: Int = 0
  ) {
    equipmentVehicle {
      get(id: $vehicleId) {
        consignments(limit: $limit, offset: $offset) {
          items {
            id
            health {
              health
              description
            }
            billOfLadingNbr
            carrier
            originCountry
            dischargeCountry
            containerNbrs
            countryOfImport
            modeOfTransport
            productDivisions
            expectedShipmentCount
            actualShipmentCount
            openExceptionCount
            steps {
              title
              status
              startTimestamp
              completedTimestamp
            }
          }
          pageInfo {
            totalCount
            status
            message
          }
        }
      }
    }
  }
`;